import { createGlobalStyle } from "styled-components";
import { COLOR_DARK_GRAY, COLOR_LIGHT_GRAY, radius } from "./config";
import { GREEN_GRADIENT } from "./styleConfig";

export const GlobalStyle = createGlobalStyle`

    *{
        font-size: large;
        font-weight: 500;
        box-sizing: border-box;
        padding: 0;
        margin: 0;
        font-family: 'Inter', sans-serif;

        &::-webkit-scrollbar{
            width: 7px;
            
        }
        &::-webkit-scrollbar-track{
            background-color: transparent;
        }
        &::-webkit-scrollbar-thumb{
            background-color: ${COLOR_LIGHT_GRAY};
            border-radius: ${radius(5)};
            
        }
    }

    .rdt_Table{
        font-size: 10px;
    }

    .rdt_TableHead{
        z-index: 10;
        background-color: white;
        
    }

    .rdt_TableHeadRow {
        ${GREEN_GRADIENT}
        color: white;
        
    }

    .rdt_TableRow {
       padding: 10px;

       
        
    }

    .rdt_TableCol{
        *{
        font-size: 15px;
       }
             
        & div{
         
        width: 100%;
        display: flex;
        justify-content: left;
        text-align: left;
        }
    }

    .rdt_TableCell{
        *{
        font-size: 14px;
       }
        display: flex;
        justify-content: left;
        text-align: left;
    }
.rdt_Pagination{
    * {
        font-size: 13px;
    }
}
`;
